/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteOrgAutoModelRequest = {
  endpoint: components.AutoEndpoint;
};

/** @internal */
export const DeleteOrgAutoModelRequest$inboundSchema: z.ZodType<
  DeleteOrgAutoModelRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  endpoint: components.AutoEndpoint$inboundSchema,
});
/** @internal */
export type DeleteOrgAutoModelRequest$Outbound = {
  endpoint: string;
};

/** @internal */
export const DeleteOrgAutoModelRequest$outboundSchema: z.ZodType<
  DeleteOrgAutoModelRequest$Outbound,
  z.ZodTypeDef,
  DeleteOrgAutoModelRequest
> = z.object({
  endpoint: components.AutoEndpoint$outboundSchema,
});

export function deleteOrgAutoModelRequestToJSON(
  deleteOrgAutoModelRequest: DeleteOrgAutoModelRequest,
): string {
  return JSON.stringify(
    DeleteOrgAutoModelRequest$outboundSchema.parse(deleteOrgAutoModelRequest),
  );
}
export function deleteOrgAutoModelRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteOrgAutoModelRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteOrgAutoModelRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteOrgAutoModelRequest' from JSON`,
  );
}
